/**
 * Author: Paul Grejaldo
 * Date: 2018/10/17
 * Time: 3:26 PM
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
import App from './containers/App';
import { each } from 'lodash';

const store = createStore( reducers );

const containers = document.getElementsByClassName( 'service-area-app' );
if ( !!containers ) {
	each( containers, container => {
		ReactDOM.render(
			<Provider store={store}>
				<App />
			</Provider>,
			container
		);
	} );
}
